import emailjs from "@emailjs/browser";
import React, { useState } from "react";

const INIT_STATE = {
  user_name: "",
  user_email: "",
  message: "",
};

export default function Contact() {
  const [formInputs, setFormInputs] =
    useState<Record<string, string>>(INIT_STATE);
  const [checkFields, setCheckFields] = useState<boolean>(false);

  const sendEmail = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setCheckFields(true);
   
    if (
      formInputs.user_name !== "" &&
      formInputs.user_email !== "" &&
      formInputs.message !== ""
    ) {
      emailjs
        .send(
          "service_89hef19",
          "template_f8e4bbm",
          formInputs,
          "i1pr-3cimjTEzctG-"
        )
        .then(
          (result) => {
            console.log(result.text);
          },
          (error) => {
            console.log(error.text);
          }
        );
      alert(
        "Thank you for getting in touch! I have received your message and would like to thank you for writing to me."
      );
      setFormInputs(INIT_STATE);
      setCheckFields(false);
    }
  };

  return (
    <>
      <section id="contact" className="projects-section-inset relative  dark:bg-gray-900 bg-corner-left">
      <div className="container px-5 py-10 mx-auto  lg:px-40">
          <h2 className="text-dark dark:text-white w-full text-center sm:text-4xl text-3xl mb-1 font-medium title-font">
            Hire Me
          </h2>
          <p className="leading-relaxed text-gray-800 dark:text-gray-400 text-center mb-5 ">
            If my work caught your attention please do contact me
          </p>
          <div className="flex flex-col md:flex-row">
            <div className="contact-detail md:w-1/2 text-center md:text-start">
              <ul className="contact-ul text-xl mt-12">
                <li className="mb-3 text-gray-800 dark:text-gray-400">
                  <i className="fa fa-location-dot mr-3 text-dark dark:text-white"> </i> Orce Nikolov 66, Skopje
                </li>
                <li className="mb-3 text-gray-800 dark:text-gray-400">
                  <i className="fa fa-phone mr-3 text-dark dark:text-white"> </i> +38970685340
                </li>
                <li className="text-gray-800 dark:text-gray-400">
                  <i className="fa-solid fa-envelope mr-3 text-dark dark:text-white"> </i> 
                  angov.vangel@gmail.com
                </li>
              </ul>
              <a href="vangel.pdf" download={"CV.pdf"}   className=" my-5 sidebar shadow-lg shadow-gray-500/30  inline-flex text-white bg-green-500 border-0 py-2 px-6 focus:outline-none hover:bg-green-600 rounded text-lg relative">Download CV</a>
            </div>

            <form
              onSubmit={sendEmail}
              className="order-first md:order-last flex flex-col md:ml-auto w-full md:w-1/2 md:pb-8 md:mt-0"
            >
              <div className="relative mb-4">
                <label
                  htmlFor="name"
                  className="leading-7 text-sm text-gray-800 dark:text-gray-400"
                >
                  Name
                </label>
                <input
                  id="name"
                  className="w-full bg-white-100 dark:bg-gray-800 rounded border border-gray-700 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-900 text-base outline-none text-gray-100 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                  type="text"
                  name="user_name"
                  value={formInputs.user_name}
                  onChange={(e) =>
                    setFormInputs({
                      ...formInputs,
                      [e.target.name]: e.target.value,
                    })
                  }
                />
                {checkFields && formInputs.user_name === "" && (
                  <p className="text-red-500">Please enter your name</p>
                )}
              </div>
              <div className="relative mb-4">
                <label
                  htmlFor="email"
                  className="leading-7 text-sm text-gray-800 dark:text-gray-400"
                >
                  Email
                </label>
                <input
                  id="email"
                  type="email"
                  className="w-full bg-white-100 dark:bg-gray-800 rounded border border-gray-700 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-900 text-base outline-none text-gray-100 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                  name="user_email"
                  value={formInputs.user_email}
                  onChange={(e) =>
                    setFormInputs({
                      ...formInputs,
                      [e.target.name]: e.target.value,
                    })
                  }
                />
                {checkFields && formInputs.user_email === "" && (
                  <p className="text-red-500">
                    Please enter your email address
                  </p>
                )}
              </div>
              <div className="relative mb-4">
                <label
                  htmlFor="message"
                  className="leading-7 text-sm text-gray-800 dark:text-gray-400"
                >
                  Message
                </label>
                <textarea
                  id="message"
                  className="w-full bg-white-100 dark:bg-gray-800 rounded border border-gray-700 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-900 h-32 text-base outline-none text-gray-100 py-1 px-3 resize-none leading-6 transition-colors duration-200 ease-in-out"
                  name="message"
                  value={formInputs.message}
                  onChange={(e) => {
                    setFormInputs({
                      ...formInputs,
                      [e.target.name]: e.target.value,
                    });
                  }}
                />
                {checkFields && formInputs.message === "" && (
                  <p className="text-red-500">Please enter a message</p>
                )}
              </div>
              <button
                type="submit"
                className="text-white text-center bg-indigo-500 border-0 py-2 px-6 focus:outline-none hover:bg-indigo-600 rounded text-lg"
              >
                Send
              </button>
            </form>
          </div>
        </div>
      </section>
    </>
  );
}
